import{not as r}from"../util/not.js";import{filter as t}from"./filter.js";function o(o,n){return function(i){return[t(o,n)(i),t(r(o,n))(i)]}}export{o as partition};
